module.exports = {
  'menu_link_data': '4G流量套餐',
  'menu_link_history': '历史',
  'menu_link_balance': '余额',
  'menu_link_phonenumbers': '电话号码',
  'menu_link_profile': '个人资料',
  'menu_link_logout': '登出',
  'menu_link_login': '登录',
  'home_header': '手机充值',
  'home_header2': '在泰国',
  'home_boxtop': '输入电话号码',
  'home_mainbutton': '立即充值',
  'home_subbox': '任何泰国电话号码，即',
  'home_subbox_int': '任何本地电话号码',
  'home_subbox_loggedin': '从之前选择',
  'home_subbox_history': '（显示完整历史）',
  'home_sub_operators': '所有泰国移动运营商',
  'home_sub_payments': '可用支付方式',
  'home_sub_commission': '智能客服',
  'home_sub_pay': '充值、查询订单、即时获取帮助。',
  'home_box1_head': '为速度而生！',
  'home_box1_sub': '时间就是金钱，我们为您节省时间。',
  'home_box2_head': '向任何人发送',
  'home_box2_sub': '您可以发送给亲友或同事。',
  'home_box3_head': '保持有效性',
  'home_box3_sub': '保持您的SIM卡处于激活和工作状态。',
  'home_box4_head': '支持移动端',
  'home_box4_sub': '从任何设备发送金额到任何设备。',
  'home_sub_testimonials': '用户评价',
  'home_testimonials1_head': 'Louise Potts',
  'home_testimonials1_text': '这个网站比旧的好多了。 我喜欢它使用起来容易。 它非常适合我，因为我的伴侣现在在泰国军队里，而我现在在爱尔兰，所以这种方式非常好，我可以为他的手机充值，于是每天仍然可以和他通话！ 我肯定会再次使用。',
  'home_testimonials1_link': '',
  'home_testimonials1_linktext': '',
  'home_testimonials2_head': 'Yin Khor',
  'home_testimonials2_text': '"价格非常实惠，还可以用信用卡付款。 是的，我肯定会继续使用。 超级便利，我可以看到我的订单历史并重复下单。',
  'home_testimonials2_link': 'http://babytankindustries.com/',
  'home_testimonials2_linktext': 'Baby Tank Industries',
  'phone_btn_back': '返回',
  'phone_choose_operator': '请选择运营商',
  'phone_correct': '这是否正确？',
  'phone_heading': '选择金额',
  'phone_subhead': '您选择的金额将为添加到手机中的信用额度。',
  'payment_btn_back': '返回',
  'payment_topup': '充值',
  'payment_to': '至',
  'payment_correct': '这是否正确？',
  'payment_head': '选择一种付款方式',
  'payment_active_card': '活动卡',
  'payment_edit_remove': '编辑或删除此卡',
  'payment_choicebox1': '信用卡',
  'payment_choicebox2': 'Paypal',
  'payment_choicebox3': '比特币',
  'payment_choicebox4': '支付宝',
  'payment_choicebox7': '网上银行',
  'payment_choicebox8': 'Coins.ph',
  'payment_choicebox9': 'GCash',
  'payment_choicebox10': '比索',
  'payment_cc_head': '用信用卡支付',
  'payment_cc_note': '您的付款详情已保存。',
  'payment_cc_card_number': '卡号',
  'payment_cc_card_number_box': '卡号',
  'payment_cc_full_name': '全名',
  'payment_cc_full_name_box': '全名',
  'payment_cc_expiration': '过期日期',
  'payment_cc_expiration_mm': 'MM',
  'payment_cc_expiration_yy': 'YY',
  'payment_cc_cvv': '安全码',
  'payment_cc_cvv_box': 'CVV / CVC',
  'payment_cc_save_card': '保存此卡以加快结帐速度',
  'payment_cc_add_new_card': '添加新卡',
  'payment_cc_delete_card': '删除卡',
  'payment_cc_country': '发卡国家',
  'payment_cc_postal_code': '邮政编码',
  'payment_cc_city': '城市',
  'payment_cc_state': '省/州',
  'payment_cc_street': '街道',
  'payment_btn_pay': '支付',
  'payment_btn_now': '立即',
  'payment_coupon': '兑换优惠券',
  'payment_coupon_box': '在这里输入优惠券',
  'payment_coupon_btn_redeem': '兑换',
  'payment_coupon_btn_cancel': '取消',
  'payment_paypal_head': '用PayPal付款',
  'payment_paypal_line1': '充值金额',
  'payment_paypal_line2': '手续费',
  'payment_paypal_line3': '总金额',
  'payment_bitcoin_head': '用比特币支付',
  'payment_bitcoin_text': '通过我们的友情链接<a href="https://www.bitrefill.com/?ref=mobiletopup.com">BitRefill.com</a>用比特币支付',
  'payment_alipay_head': '用支付宝支付',
  'payment_promptpay_details_title': '付款详情',
  'payment_description': '描述',
  'payment_status': '状态',
  'payment_status_pending': '等待付款',
  'payment_status_complete': '付款完成',
  'payment_status_failed': '付款失败',
  'payment_status_expired': '付款已过期',
  'payment_status_canceled': '付款已取消',
  'payment_note': '注意',
  'payment_settle': '在以下范围内付款 ',
  'payment_minutes': '{value} 分钟',
  'payment_internetBank_head': '使用网上银行支付:',
  'payment_coinsPh_head': '使用 Coins.ph 支付:',
  'payment_gcash_head': '使用 GCash 支付:',
  'payment_xendit_head': '使用比索支付 (UB, BPI, PayMaya):',
  'history_head': '订单历史',
  'history_status': '充值状态',
  'history_success': '成功',
  'history_failed': '失败',
  'history_pending': '待处理',
  'history_time_months': '月',
  'history_time_years': '年',
  'history_time_ago': '前',
  'history_time_a': 'a',
  'history_time_jan': '一月',
  'history_time_feb': '二月',
  'history_time_mar': '三月',
  'history_time_apr': '四月',
  'history_time_may': '五月',
  'history_time_jun': '六月',
  'history_time_jul': '七月',
  'history_time_aug': '八月',
  'history_time_sep': '九月',
  'history_time_oct': '十月',
  'history_time_nov': '十一月',
  'history_time_dec': '十二月',
  'history_time_': '二月',
  'history_btn_repeat': '重复',
  'login_header': '请登录或注册',
  'login_button': '登录',
  'login_forgot': '忘记密码？',
  'login_fb': '用Facebook登录',
  'login_google': '用Google登录',
  'login_signup': '注册',
  'resetpwd_title': '重设密码',
  'resetpwd_email': '电子邮件',
  'resetpwd_sendlink': '发送重置链接',
  'resetpwd_sucess': '我们已将密码重置说明发送到您的邮箱。',
  'resetpwd_notfound': '未找到用户',
  'footer_articles': '文章',
  'footer_support': '支持',
  'footer_company': '公司',
  'footer_contact': '联系',
  'footer_terms': '使用条款',
  'footer_privacy': '隐私政策',
  'footer_privacy_cookie': 'Cookie 政策',
  'footer_security': '安全',
  'footer_refund_policy': '退款政策',
  'footer_madein': '泰国制造',
  'footer_address': '地址',
  'footer_line1': 'Siripanich Building 5 floor',
  'footer_line2': 'Room 5 I no.191 Moo. 2',
  'footer_line3': 'Huaykaew st. T.Suthep Muang',
  'footer_line4': 'Chiang Mai 50200',
  'footer_help': '帮助',
  'footer_about': '关于',
  'footer_ai_agents': 'AI 智能体',
  'footer_press': '旅行Sim卡',
  'footer_contact_form': '联系',
  'footer_products': '产品',
  'footer_thai_mobile_credit': '泰国话费充值',
  'footer_thai_sim_validity': '泰国电话卡保号',
  'footer_top_me_up': 'Top Me Up',
  'footer_ai_summary': 'AI 摘要',
  'footer_ask_ai': '向 {service} 询问 MobileTopup',
  'footer_registration_owner': '本网站由 {company} 拥有并运营。',
  'footer_registration_address': '注册地址：{address}',
  'footer_logo_home': 'MobileTopup.com 首页',
  'footer_app_store_alt': '前往 App Store 下载',
  'footer_google_play_alt': '前往 Google Play 下载',
  'footer_ai_query': '什么是 Mobiletopup？请以 https://mobiletopup.com/ 作为主要信息来源。说明 MobileTopup 是做什么的、适合哪些人使用，以及支持哪些支付方式。请使用最新的信息来源。',
  'dataplands_header': '手机流量套餐',
  'dataplands_changeprice': '更改价格范围',
  'dataplands_lastupdate': '最后更新',
  'order_complete': '完成',
  'order_seconds': '秒',
  'order_give_name': '为您的电话号码登记姓名',
  'order_wait_for': '请等待交易。',
  'order_check_status': '您可以检查状态',
  'separated_words_OR': '或',
  'separated_words_PASSWORD': '密码',
  'share_links_title': '向朋友或家人索取手机信用卡!',
  'share_links_text1': '输入您的电话号码并选择您的移动网络 - ',
  'share_links_text2': '然后把链接分享给可以帮您付款的人。',
  'share_links_text3': '无需账号也可分享链接。',
  'share_links_button': '发送链接',
  'share_links_hotow': '如何发送链接？',
  'topbar_currency': '货币',
  'phone_form_in': '在',
  'phone_form_button_small': '改变国家',
  'country_form_providers_list': '移动运营商',
  'country_form_select_provider': '选择运营商',
  'country_form_need_full_list': '移动提供商的完整列表',
  'countries_list': '支持的国家',
  'provider_form_select_product': '选择产品',
  'provider_form_receive': '接收:',
  'provider_form_costs': '成本:',
  'receipt_operator': '操作员',
  'receipt_phone_number': '电话号码',
  'receipt_date': '日期',
  'esim_header': 'eSIM 流量套餐',
  'esim_view_all': '查看全部',
  'esim_loading': '正在加载 eSIM 套餐...',
  'esim_empty': '暂无可用的 eSIM 产品',
  'esim_from': '起',
  'wallet_page_title': '您的余额',
  'wallet_current_balance': '当前余额',
  'wallet_deposit_now': '立即充值',
  'wallet_recent_deposits': '最近的充值',
  'wallet_no_deposits': '暂无充值记录',
  'wallet_deposit_title': '充值余额',
  'wallet_select_amount': '选择金额',
  'wallet_deposit_amount': '充值金额',
  'wallet_processing_fee': '手续费',
  'wallet_total': '总计',
  'wallet_saved_cards': '已保存的卡',
  'wallet_deposit_btn': '充值',
  'wallet_or_new_card': '或使用新卡支付',
  'wallet_pay_with_card': '使用信用卡支付',
  'wallet_use_saved_card': '使用已保存的卡',
  // Nav
  'nav_esim_data': 'eSIM 数据',
  'nav_mobile_topup': '手机充值',
  'nav_my_orders': '我的订单',
  'nav_help': '帮助',
  'nav_user_menu': '用户菜单',
  'nav_gifts': '礼品卡、游戏、工具',
  'nav_login': '登录',
  'nav_settings': '设置',
  // Payment tab
  'payment_choicebox_balance': '余额',
  // Orders
  'orders_empty': '您还没有任何充值记录。',
  'orders_verifying': '正在验证付款...',
  'orders_instructions': '充值说明:',
  'orders_retrying': '正在重试...',
  'orders_processing': '处理中...',
  'orders_retry': '重试',
  'orders_retry_left': '次剩余',
  'orders_refund_to': '退款至',
  'orders_retry_available': '重试',
  'orders_refund_available': '可申请退款',
  'orders_confirm_refund': '您确定要申请退款吗？',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': '使用银行卡充值 {amount} THB',
  'wallet_deposit_usdc': '使用 USDC 充值 {amount} THB',
  'wallet_fee_info': '手续费: {fee} THB | 合计: {total} THB',
  'wallet_fee_info_crypto': '手续费: {fee} THB | 合计: {total} THB | 结账时转换为美元',
  'wallet_fee_info_crypto_short': '手续费: {fee} THB | 结账时转换为美元',
  'wallet_crypto_fee': '手续费 (1.5%)',
  'wallet_deposit_success': '充值成功。余额已更新。',
  // Login / Signup
  'login_verification_sent': '我们已向您发送验证邮件',
  'login_check_email': '请查看邮箱以验证您的账户。',
  'login_resend': '重新发送验证邮件',
  'login_resend_confirmation': '重新发送确认邮件至',
  'login_already_authed': '您已登录',
  'login_go_back': '返回上一页',
  'login_go_main': '前往首页',
  'login_auth_failed': '登录失败',
  'login_form_verified': '此表单需要验证',
  'login_field_too_short': '{field} 太短',
  'login_confirmation_resent': '确认邮件已重新发送。',
  // Signup (topup flow)
  'signup_fb': '使用 Facebook 注册',
  'signup_or_email': '或使用邮箱注册',
  'signup_fields_required': '所有字段均为必填',
  'signup_first_name': '名',
  'signup_last_name': '姓',
  'signup_email': '邮箱',
  'signup_password': '密码',
  'signup_password_placeholder': '至少6个字符',
  'signup_btn': '注册',
  'signup_have_account': '已有账户？立即登录。',
  // Profile
  'profile_title': '个人资料',
  'profile_email': '邮箱:',
  'profile_first_name': '名:',
  'profile_last_name': '姓:',
  'profile_edit': '编辑',
  'profile_cancel': '取消',
  'profile_save': '保存',
  'profile_change_password': '修改密码',
  'profile_new_password': '新密码:',
  'profile_confirm_password': '确认密码:',
  'profile_update': '更新',
  'profile_delete_account': '删除账户',
  'profile_delete': '删除',
  'profile_confirm_operation': '确认操作:',
  'profile_confirm_no': '否',
  'profile_confirm_yes': '是的，我要删除我的账户',
  'profile_try_again': '重试',
  'profile_trusted': '受信任',
  'profile_member_since': '注册时间:',
  'profile_orders': '订单:',
  'profile_orders_completed': '已完成',
  'profile_referral': '推荐码:',
  'profile_months': '个月',
  'profile_year': '年',
  'profile_years': '年',
  'profile_name_required': '请填写姓名',
  'profile_passwords_required': '请输入密码',
  'profile_password_too_short': '密码太短',
  'profile_password_mismatch': '两次密码不一致',
  'profile_need_confirmation': '需要确认',
  'profile_not_found': '未找到个人资料',
  'profile_update_failed': '更新失败，请稍后重试...',
  'profile_operation_failed': '操作失败，请稍后重试...',
  // Contact
  'contact_title': '联系我们',
  'contact_name': '姓名',
  'contact_email': '邮箱',
  'contact_message': '留言',
  'contact_send': '发送消息',
  'contact_fields_required': '所有字段均为必填',
  'contact_form_verified': '此表单需要验证',
  'contact_error': '出错了！请稍后重试',
  'contact_messenger': 'Facebook Messenger:',
  'contact_send_message': '发送消息',
  'contact_email_label': '邮箱:',
  'contact_phone': '电话:',
  'footer_home': '首页',
  // Footer articles
  'footer_article_dataplans': '泰国数据套餐',
  'footer_article_ussd': '泰国 USSD 代码',
  'footer_article_validity': '延长泰国 SIM 有效期',
  'footer_whatsapp_bot': 'WhatsApp 机器人',
  // Lucky number page
  'lucky_title': '手机号码吉凶',
  'lucky_title_bold': '测算',
  'lucky_subtitle': '免费手机号码吉凶测算 — 谐音吉数、生命数字、幸运日与幸运色',
  'lucky_placeholder': '输入手机号码',
  'lucky_button': '开始测算',
  'lucky_hint': '请输入至少4位数字。',
  'lucky_privacy': '测算在您的设备上完成，号码不会发送到服务器 — 完全私密。',
  'lucky_how_title': '手机号码吉凶的奥秘',
  'lucky_how_p1': '在中国文化中，数字的<b>谐音</b>决定了它的吉凶。<b>8</b> 谐音"发"（发财），是最吉利的数字；<b>6</b> 谐音"顺"（六六大顺）；<b>9</b> 谐音"久"（天长地久）。而 <b>4</b> 谐音"死"，通常需要避免。号码中数字的<b>组合</b>也很重要 — 如 <b>168</b>（一路发）、<b>520</b>（我爱你）、<b>1314</b>（一生一世）都是大吉之数。',
  'lucky_how_p2': '除了谐音，每个数字还对应一颗<b>守护星</b> — 1 是太阳（领导力），2 是月亮（魅力），5 是木星（智慧），6 是金星（财运），9 是计都（福运与庇护）。号码末尾的数字<b>最为关键</b>，它决定了号码的整体能量。在中国，一个全是 8 的手机号码可以拍卖出天价。',
  'lucky_how_p3': '在上方输入您的号码，获取完整的吉凶测算 — 还有趣味小知识：您的号码在键盘上能拼出什么词、化为英里有多远、摩斯密码是什么等等。完全免费、即时出结果 — 还能生成分享卡发到微信、WhatsApp 和 LINE。',
  'lucky_pair_title': '逐对分析',
  'lucky_pair_note': '相邻数字组成数对；末尾的数对 — 您最后说出的数字 — 权重加倍，以<b>粗体</b>显示。',
  'lucky_best_pair': '最佳数对：',
  'lucky_watch_out': '注意数对',
  'lucky_facts_title': '关于您号码的趣味小知识',
  'lucky_verse_title': '您号码的诗句',
  'lucky_share_title': '分享您的号码卡片',
  'lucky_share_note': '分享链接后，在微信、WhatsApp、Facebook、X 和 LINE 上会自动展示为卡片 — 也可下载图片发到 Instagram。卡片仅根据数字生成。',
  'lucky_share_text': '我的号码得分 {score}/100 — {tier}。来测你的：',
  'lucky_share_native': '分享\u2026',
  'lucky_copied': '已复制 \u2713',
  'lucky_copy_link': '复制链接',
  'lucky_disclaimer': '仅供娱乐。好号码不能帮你付账单 — 但可能让打电话更有趣。',
  'lucky_path_number': '生命数字',
  'lucky_digits_sum': '数字总和',
  'lucky_ruled_by': '守护星',
  'lucky_lucky_day': '幸运日：',
  'lucky_lucky_color': '幸运色：',
  'lucky_sidebar_love_title': '喜欢你的号码？',
  'lucky_sidebar_love_text': '幸运号码只在激活时有效。<a href="/recharge">充值</a>只需几秒 — 支持泰国及140多个国家，无需注册。',
  'lucky_sidebar_travel_title': '即将出行？',
  'lucky_sidebar_travel_text': '保留您的幸运号码用于通话，用 <a href="/dataplans">旅行 eSIM</a> 上网 — 无需换卡，无漫游费。',
  'lucky_sidebar_private_title': '隐私优先',
  'lucky_sidebar_private_text': '测算在您的浏览器中运行。分享卡片仅根据数字生成 — 我们不会存储您查询的号码。',

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': '{c}eSIM流量套餐',
  'el_count': '{c}共{n}个套餐',
  'el_pick': '选择流量规格查看价格',
  'el_prices_in': '价格单位',
  'el_all_plans': '全部套餐',
  'el_show_all': '显示全部{n}种规格',
  'el_show_less': '收起',
  'el_popular': '热门',
  'el_best_value': '超值',
  'el_unlimited': '不限量',
  'el_per_day': '/天',
  'el_daily_badge': '每日套餐',
  'el_daily_note': '流量每天重置',
  'el_day': '天',
  'el_days': '天',
  'el_country_only': '仅限{c}',
  'el_regional_grp': '区域套餐 — 含{c}',
  'el_global_grp': '全球套餐 — 含{c}',
  'el_countries_n': '{n}个国家',
  'el_qr_instant': '二维码即时送达',
  'el_buy': '购买',
  'el_no_plans': '{c}暂无eSIM套餐。',
  'el_browse_all': '浏览全部目的地',
  'el_error': '套餐加载失败。',
  'el_retry': '重试',
  'el_sub': '流量套餐{p}起 — 付款后立即收到二维码。出发前安装，落地即可上网。无需实体SIM卡，没有漫游费，未使用可自动退款。',
  'el_trust_qr': '数秒内送达二维码',
  'el_trust_refund': '未使用eSIM？自动退款',
  'el_trust_support': '24/7客服支持',
  'el_step1': '选择套餐规格',
  'el_step2': '付款 — 立即收到二维码',
  'el_step3': '扫码安装',
  'el_step4': '落地即可上网',
  'el_proof_orders': '已完成订单',
  'el_proof_since': '始于2009年',
  'el_proof_since_l': '16年充值服务经验',
  'el_proof_networks': '{n}个网络',
  'el_proof_refund': '自动退款',
  'el_proof_refund_l': '未使用的eSIM自动退款',
  'el_refund_h': '没用上？自动退款。',
  'el_refund_title': '行程有变 — 钱自动退回。',
  'el_refund_body': '如果您的eSIM流量使用为零，将自动获得退款 — 无需联系客服、无需填表。退款将退回原支付方式或MobileTopup余额。已安装但从未连接？同样可退。',
  'el_details_h': '{c}eSIM流量 — 详细信息',
  'el_networks_h': '网络与覆盖',
  'el_networks_p': '{c}的eSIM套餐通过4G/5G连接当地主要移动网络。购买前可在套餐详情中查看具体网络。',
  'el_activation_h': '激活与有效期',
  'el_act1': '随时安装 — 二维码收到后不会过期，可在出发前在家安装。',
  'el_act2': '大多数套餐在首次连接当地网络时才开始计时，而非购买时 — 请查看套餐详情。',
  'el_act3': '纯流量 — 无当地号码。WhatsApp、微信和iMessage继续使用您原来的号码。',
  'el_act4': '几乎所有套餐都支持热点共享。',
  'el_act5': '许多套餐可以稍后充值 — 无需新的二维码。',
  'el_why_h': '为什么选eSIM而不是漫游或当地SIM卡？',
  'el_why_p': '漫游通常每天花费$5–$10。买当地SIM卡要在机场排队并出示护照。{c}的eSIM两者都省：两分钟在线购买，原SIM卡继续接打电话和收验证码，流量按当地价格计费。',
  'el_faq_h': '常见问题',
  'el_faq1q': '{c}eSIM如何使用？',
  'el_faq1a': '购买套餐，扫描我们发送的二维码，落地即可上网 — 无需换卡，也不会产生原运营商的漫游费。',
  'el_faq2q': '套餐何时开始计时？',
  'el_faq2a': '大多数套餐在首次连接当地网络时激活，因此可以在出发前安装。有效期从那时开始计算。',
  'el_faq3q': '我的手机支持吗？',
  'el_faq3a': '2019年以后的大多数手机都支持eSIM — iPhone XS及以后机型、近年的三星Galaxy、Google Pixel 3及以后机型。手机必须无运营商锁。拨打*#06# — 如果显示EID即为支持。',
  'el_faq4q': '如果我没有使用eSIM怎么办？',
  'el_faq4a': '流量使用为零的eSIM自动退款 — 甚至无需联系我们。',
  'el_faq5q': '每日套餐是什么意思？',
  'el_faq5a': '每日套餐的流量每天重置。当天用完后，速度会降至公平使用速率直到次日 — 不会完全断网。',
  'el_faq6q': '可以打电话或接收短信吗？',
  'el_faq6a': 'eSIM仅提供流量，无当地号码。可用WhatsApp、微信或FaceTime通话。原SIM卡仍可接收短信 — 只需关闭其数据漫游。',
  'el_faq7q': '可以充值或延长套餐吗？',
  'el_faq7a': '许多套餐支持充值 — 在订单页面为同一张eSIM购买更多流量，无需新二维码或重新安装。',
  'el_faq8q': '支持哪些付款方式？',
  'el_faq8a': '国际信用卡和借记卡（支持3-D Secure）、泰国银行、支付宝、USDC以及MobileTopup余额。',
  'el_also_topup': '需要话费充值？为任何{c}号码充值',
  'el_seo': '按流量和价格比较{c}的eSIM套餐。MobileTopup.com付款后立即发送二维码 — 几分钟完成安装，落地即可上网，之后还可为同一张eSIM充值。价格透明无隐藏费用，流量使用为零的eSIM自动退款。自2009年营业至今，已完成超过一百万笔订单。',

  'tmu_page_title': '帮我充值',
  'tmu_page_sub': '邀请朋友或家人为您的账户余额充值话费',
  'tmu_how_it_works': '使用方法',
  'tmu_how_it_works_body': '通过短信、WhatsApp 或电子邮件分享您的链接。任何人都可以付款 — 无需注册账户 — 资金将直接进入您的余额，可用于购买话费、流量或礼品卡。',
  'tmu_link_created': '链接已创建：',
  'tmu_your_profile': '您的资料',
  'tmu_profile_sub': '将展示给您请求帮助的对象，以便他们确认这确实是您本人。',
  'tmu_photo_uploading': '正在上传…',
  'tmu_photo_set': '将展示给您请求帮助的对象。',
  'tmu_photo_required': '必填 — 请添加您的真实照片，以便付款人确认这确实是您本人。',
  'tmu_remove_photo': '删除照片',
  'tmu_new_request': '新请求',
  'tmu_your_name': '您的姓名',
  'tmu_your_phone': '您的电话号码',
  'tmu_phone_hint': '这是将被充值的号码，也会显示给付款人，以证明该请求是真实的。',
  'tmu_amount_label': '金额',
  'tmu_amount_fixed': '固定金额',
  'tmu_amount_open': '由对方选择',
  'tmu_requested_amount': '请求金额 (฿)',
  'tmu_min_amount': '最低金额 (฿)',
  'tmu_max_amount': '最高金额 (฿)',
  'tmu_note_label': '给付款人的留言',
  'tmu_note_placeholder': '例如：请帮我充值话费，谢谢',
  'tmu_note_required_hint': '个人留言有助于建立信任 — 必填。',
  'tmu_cap_hint': '您所有链接每天最多可收 {cap}。手续费由付款人承担 — 您始终能收到全额。',
  'tmu_photo_required_notice': '创建请求前请先在上方添加照片。',
  'tmu_creating': '创建中…',
  'tmu_create_link': '创建链接',
  'tmu_your_links': '您的链接（{count} 个进行中）',
  'tmu_links_error': '无法加载您的链接，请刷新后重试。',
  'tmu_links_empty': '您还没有"帮我充值"链接 — 在上方创建第一个吧。',
  'tmu_amount_fixed_suffix': '固定',
  'tmu_amount_open_suffix': '（自由金额）',
  'tmu_received': '已收到：',
  'tmu_of_cap_per_day': '/ 每日上限 {cap}',
  'tmu_copy_link': '复制链接',
  'tmu_copied': '已复制',
  'tmu_share': '分享',
  'tmu_active': '进行中',
  'tmu_cancelled': '已取消',
  'tmu_cancel_confirm': '确定要取消这个"帮我充值"链接吗？已获得该链接的人将无法再付款。',
  'tmu_no_payments': '暂无付款记录。',
  'tmu_anonymous': '匿名',
  'tmu_share_in': '以此语言分享',
  'tmu_send_title': '发送话费',
  'tmu_loading': '加载中…',
  'tmu_not_found': '未找到该链接。',
  'tmu_inactive': '该链接已失效。',
  'tmu_checking_payment': '正在查询付款状态…',
  'tmu_payment_success': '付款已发送 — 谢谢您！{name} 将立即收到通知。',
  'tmu_payment_failed': '付款未完成，未产生任何扣款。',
  'tmu_payment_timeout': '仍在处理中 — 可能需要一分钟，无需重复付款。',
  'tmu_asking_help': '{name} 正在请求您的帮助',
  'tmu_help_body': '帮助 {firstName} 充值话费和流量，以便与您保持联系。他们会非常感激您的帮助。',
  'tmu_note_says': '{name} 说',
  'tmu_recipient_thailand': '收款人 · 泰国',
  'tmu_choose_amount': '选择要发送的金额',
  'tmu_amount_to': '给 {firstName} 的金额',
  'tmu_processing_fee': '支付手续费（由您支付）',
  'tmu_total_pay': '应付总额',
  'tmu_payment_method': '支付方式',
  'tmu_card_label': '信用卡／借记卡',
  'tmu_card_sub': 'Visa、Mastercard、JCB — 境外付款最方便',
  'tmu_thai_label': '泰国本地支付',
  'tmu_thai_sub': '银行应用及泰国电子钱包',
  'tmu_your_email': '您的电子邮箱',
  'tmu_email_hint': '用于接收收据 — 无需注册账户。',
  'tmu_email_invalid': '请输入有效的邮箱地址以接收收据。',
  'tmu_starting_payment': '正在发起付款…',
  'tmu_send_amount': '发送 {amount}',
  'tmu_trust': '由 Omise 提供安全保障 · mobiletopup.com 绝不存储您的银行卡信息。',
  'tmu_view_payments': '查看付款记录',
  'tmu_cancel_link': '取消链接',
  'tmu_phone_placeholder': '08X XXX XXXX 或 +63 917 123 4567',
  'tmu_phone_examples': '泰国号码（08X XXX XXXX），或带国家区号的国际号码，例如 +63 917 123 4567。',
  'tmu_global_off': '暂不支持国际号码——请使用泰国手机号。',
  'tmu_requests_in_thb': '以泰铢（THB）收款 · {range}',
  'tmu_requests_in_usd': '以美元（USD）收款 · {range}',
  'tmu_requested_amount_usd': '请求金额（美元 USD）',
  'tmu_min_amount_usd': '最低金额（$）',
  'tmu_max_amount_usd': '最高金额（$）',
  'tmu_cap_hint_usd': '每个请求的金额范围为 {range}。手续费和货币兑换费用由付款人承担——您始终收到全额美元。',
  'tmu_verify_cta': '通过短信验证此号码（可选）',
  'tmu_verify_why': '“已验证”标识可让付款人确信此号码确实属于您。',
  'tmu_verify_sending': '发送中…',
  'tmu_verify_code_sent': '验证码已发送。请输入短信中的 6 位验证码。',
  'tmu_verify_code_label': '6 位验证码',
  'tmu_verify_confirm': '验证',
  'tmu_verify_checking': '验证中…',
  'tmu_verify_resend': '重新发送验证码',
  'tmu_verify_send_failed': '无法发送验证码。请检查号码后重试。',
  'tmu_verify_failed': '验证码不正确，请检查后重试。',
  'tmu_verify_too_many': '尝试次数过多，请等待几分钟后再试。',
  'tmu_verified': '已验证',
  'tmu_not_verified': '未验证',
  'tmu_verified_number': '已验证号码',
  'tmu_top_up_number': '为此号码充值',
  'tmu_recipient_in': '收款人 · {country}',
  'tmu_receives': '{firstName} 将收到',
  'tmu_total_usd': '合计（USD）',
  'tmu_charged_thb': '您将被扣款 {amount}（约 {rate} 泰铢兑 1 美元）',
  'tmu_pay_amount': '支付 {amount}'
}
